const generateTestIdFrom = (name: string, text: string) =>
  `${text?.toLocaleLowerCase().split(' ').join('-')}-${name}`;

export default generateTestIdFrom;
